<template>
<div class="chapter">
<div class="inner_page">
<div id="Epub4211-4.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="PN-I para-style-override-4" id="toc_marker-5"><span class="char-style-override-6">Copyright © 2013 by John Lawton</span></p>
<p class="BT-1st-Para para-style-override-5"><span class="char-style-override-7">All rights reserved. No part of this book may be reproduced in any form or by <br/>any electronic or mechanical means, including information storage and retrieval <br/>systems, without permission in writing from the publisher, except by a reviewer, <br/>who may quote brief passages in a review. Scanning, uploading, and electronic <br/>distribution of this book or the facilitation of such without the permission of the publisher is prohibited. Please purchase only authorized electronic editions, <br/>and do not participate in or encourage electronic piracy of copyrighted <br/>materials. Your support of the author’s rights is appreciated. Any member of <br/>educational institutions wishing to photocopy part or all of the work for <br/>classroom use, or anthology, should send inquiries to <br/>Grove/Atlantic, Inc., 154 West 14th Street, New York, NY 10011 or <br/></span><a href="mailto:permissions@groveatlantic.com"><span class="char-style-override-7">permissions@groveatlantic.com</span></a><span class="char-style-override-7">.</span></p>
<p class="BT-1st-Para para-style-override-6"><span class="char-style-override-7">eBook ISBN-13: 978-0-8021-9308-7</span></p>
<p class="BT-1st-Para para-style-override-6"><span class="char-style-override-7">Atlantic Monthly Press</span></p>
<p class="BT-1st-Para para-style-override-4"><span class="char-style-override-8">an imprint of Grove/Atlantic, Inc.</span></p>
<p class="BT-1st-Para para-style-override-4"><span class="char-style-override-7">154 West 14th Street</span></p>
<p class="BT-1st-Para para-style-override-4"><span class="char-style-override-7">New York, NY 10011</span></p>
<p class="BT-1st-Para para-style-override-7"><span class="char-style-override-7">Distributed by Publishers Group West</span></p>
<p class="BT-1st-Para para-style-override-7"><a href="http://www.groveatlantic.com" target="_blank"><span class="char-style-override-7">www.groveatlantic.com</span></a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epub42114.vue?13fd46e9